<template>
  <div>
    <a-modal :visible="isShow" title="添加包装" @ok="doAddGift" @cancel="handleClose">
      <a-form>
        <a-form-item label="包装名称">
          <a-select v-model="gift.gift_id" placeholder="请选择包装">
            <a-select-option v-for="item in giftList" :key="item.spec_id" :value="item.spec_id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="包装数量">
          <a-input v-model="gift.num" type="number" style="width: 150px"></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'BatchSettingGift',
  model: {
    prop: 'isShow',
    event: 'hiddenGift'
  },
  props: {
    isShow: {
      type: Boolean,
      required: false,
      default: false
    },
    orderIds: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      giftList: [],
      gift: {
        gift_id: "",
        num: 1
      },
    }
  },
  created() {
    this.getGiftList()
  },
  methods: {
    getGiftList () {
      this.$util.api("/goods/gift", {}, (res) => {
        if (res.code === 10000) {
          this.giftList = res.data;
        }
      });
    },
    doAddGift () {
      if (this.orderIds.length == 0) {
        this.$message.error('请至少选择一个订单')
        return
      }
      this.gift.ids = this.orderIds
      this.$util.api("/order/third/gift",this.gift,(res) => {
        this.$message.success(res.msg)
        this.$emit("refreshData")
        this.handleClose()
      })
    },
    handleClose () {
      this.$emit("hiddenGift",false)
      this.gift = {gift_id: "",num:1}
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/deal/third/components/BatchSettingGift.vue